module.exports = __webpack_public_path__ + "static/media/branding-logo.27ab43e4.png";